<template>
  <section class="admin-remote-frame">
    <el-alert v-if="!source" :title="t('admin.remote.invalid')" type="error" :closable="false" show-icon />
    <template v-else>
      <el-alert :title="title" type="info" :closable="false" show-icon />
      <iframe
        :title="title"
        :src="source"
        class="admin-remote-frame__content"
        referrerpolicy="no-referrer"
      />
    </template>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

import { normalizeAdminExternalUrl } from '@/router/admin-menu-url'

const route = useRoute()
const { t } = useI18n()
const source = computed(() => normalizeAdminExternalUrl(
  typeof route.meta.externalUrl === 'string' ? route.meta.externalUrl : null
))
const title = computed(() => String(route.meta.title || t('admin.remote.title')))
</script>

<style scoped>
.admin-remote-frame { height: calc(100vh - var(--admin-header-height) - var(--admin-tabs-height)); padding: 16px; }
.admin-remote-frame__content { width: 100%; height: calc(100% - 52px); margin-top: 12px; border: 1px solid var(--admin-color-border); border-radius: 6px; background: white; }
</style>
